import { render } from "./SuccessStories.vue?vue&type=template&id=021217ae"
import script from "./SuccessStories.vue?vue&type=script&lang=js"
export * from "./SuccessStories.vue?vue&type=script&lang=js"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__